import './listing-rooms.css';
import { IListing } from '../../../models/listing.model';

export interface ListingRoomsProps {
  listing: IListing;
}

export const ListingRooms = (props: ListingRoomsProps) => {

  return (
    <div id='rooms' className="listing-rooms-container">
      <h2 className="title">Room Details</h2>
      <div className="listing-rooms">
        {props.listing.rooms.map((room, i) =>
          <div className="room-container" key={i}>
            <div className="room-name">
              {room.name}
            </div>
            {
              room.length && room.width &&
              <div className="room-dimensions">
                {room.length}
                {' x '}
                {room.width}
                {' '}
                {room.measuredIn}
                {
                  room.totalSize &&
                  <span className="total-size">
                    {' '}
                    ({room.totalSize}
                    {' '}
                    {room.measuredIn}&sup2;)
                  </span>
                }
              </div>
            }
            {
              room.descriptions &&
              <div className="descriptions">
                <ul>
                  {
                    room.descriptions.map((description, x) =>
                      <li key={x}>
                        {description}
                      </li>
                    )
                  }
                </ul>
              </div>
            }
          </div>
        )}
      </div>
    </div>
  );
}
